var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefreshCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#064AD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6778 12.4233L16.6886 12.4251L16.6995 12.4264C16.8222 12.4414 16.9218 12.5546 16.8965 12.7097L16.8964 12.7097L16.895 12.7199C16.7397 13.8156 16.2577 14.7853 15.5064 15.5366C14.5345 16.5084 13.2637 16.9901 11.99 16.9901C10.8881 16.9901 9.78848 16.6017 8.87471 15.8616L8.06 15.2016V16.2501V17.1901C8.06 17.324 7.94386 17.4401 7.81 17.4401C7.67614 17.4401 7.56 17.324 7.56 17.1901V14.5201C7.56 14.3863 7.67614 14.2701 7.81 14.2701H10.48C10.6139 14.2701 10.73 14.3863 10.73 14.5201C10.73 14.654 10.6139 14.7701 10.48 14.7701H9.73001H8.12559L9.44596 15.6816C11.1882 16.8843 13.5974 16.7298 15.1535 15.1737C15.8308 14.4964 16.2698 13.6168 16.405 12.6409C16.4287 12.4839 16.5588 12.4035 16.6778 12.4233Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33999 12.0803C7.70999 12.0803 8.02998 11.8103 8.07998 11.4403C8.19998 10.5703 8.58999 9.79031 9.18999 9.19031C10.57 7.81031 12.71 7.6703 14.26 8.7403H13.51C13.1 8.7403 12.76 9.0803 12.76 9.4903C12.76 9.9003 13.1 10.2403 13.51 10.2403H16.18C16.59 10.2403 16.93 9.9003 16.93 9.4903V6.82031C16.93 6.41031 16.59 6.07031 16.18 6.07031C15.77 6.07031 15.43 6.41031 15.43 6.82031V7.76031C13.28 6.02031 10.13 6.1303 8.14001 8.1203C7.31001 8.9503 6.77998 10.0203 6.60998 11.2203C6.54998 11.6303 6.83999 12.0103 7.24999 12.0703C7.26999 12.0803 7.30999 12.0803 7.33999 12.0803Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCircle);
export default __webpack_public_path__ + "static/media/refresh-circle.2ea0e11b9e63650deba396cd6d5c260a.svg";
export { ForwardRef as ReactComponent };